import { useEffect } from "react";

/** Sets `document.title` to `${title} · PCG Platform` for the lifetime of the calling component. */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · PCG Platform`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
